/* tslint:disable */
/* eslint-disable */
/**
 * Warpgate Web Admin
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0.19.1-30-g35acb1d6-modified
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { TargetOptionsFromJSON, TargetOptionsToJSON, } from './TargetOptions';
/**
 * Check if a given object implements the TargetDataRequest interface.
 */
export function instanceOfTargetDataRequest(value) {
    if (!('name' in value) || value['name'] === undefined)
        return false;
    if (!('options' in value) || value['options'] === undefined)
        return false;
    return true;
}
export function TargetDataRequestFromJSON(json) {
    return TargetDataRequestFromJSONTyped(json, false);
}
export function TargetDataRequestFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'name': json['name'],
        'description': json['description'] == null ? undefined : json['description'],
        'options': TargetOptionsFromJSON(json['options']),
        'rateLimitBytesPerSecond': json['rate_limit_bytes_per_second'] == null ? undefined : json['rate_limit_bytes_per_second'],
        'groupId': json['group_id'] == null ? undefined : json['group_id'],
    };
}
export function TargetDataRequestToJSON(value) {
    if (value == null) {
        return value;
    }
    return {
        'name': value['name'],
        'description': value['description'],
        'options': TargetOptionsToJSON(value['options']),
        'rate_limit_bytes_per_second': value['rateLimitBytesPerSecond'],
        'group_id': value['groupId'],
    };
}
